import { saveRequestAccessHandoff } from './RequestAccessNavigationHandoff';
import {
  BatchExecutionResult,
  EditOrRenewActionContext,
  LifecycleGridItem,
  RequestAccessHandoffPayload,
} from './MyAccessRequests.types';
import { evaluateRenewEligibility, isEditRenewSupportedTenant } from './MyAccessRequests.lifecycleEligibility';

const buildRenewHandoff = (tenantName: string, item: LifecycleGridItem): RequestAccessHandoffPayload => ({
  version: 1,
  tenantName,
  action: 'renew',
  requestedAtUtc: new Date().toISOString(),
  item,
});

export async function executeRenewSelected(context: EditOrRenewActionContext): Promise<BatchExecutionResult> {
  const { item, tenantName, updateRowExecutionState } = context;

  if (!isEditRenewSupportedTenant(tenantName)) {
    updateRowExecutionState(item.requestId, 'failed', 'Renew from Request History is not supported for this tenant yet');
    return { total: 1, successCount: 0, failedCount: 1 };
  }

  const eligibility = evaluateRenewEligibility(item, {
    tenantName,
    allItems: context.allItems,
    accessExpiryReminderWindowDays: context.accessExpiryReminderWindowDays,
    approvedAccesses: context.approvedAccesses,
  });

  if (!eligibility.isEligible) {
    updateRowExecutionState(item.requestId, 'failed', eligibility.reason || 'Item is not eligible for renew');
    return { total: 1, successCount: 0, failedCount: 1 };
  }

  saveRequestAccessHandoff(buildRenewHandoff(tenantName, item));
  updateRowExecutionState(item.requestId, 'success', 'Redirecting to Access Request for renew');
  context.navigateToRequestAccess();

  return { total: 1, successCount: 1, failedCount: 0 };
}
